// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.style-button-container[data-v-6e45a146] {\n  width: 100px;\n}\n.style-icon[data-v-6e45a146] {\n  -webkit-text-stroke: 1px #4a4a4a;\n  font-size: 25px;\n}\n", ""]);
// Exports
module.exports = exports;
